import { Component } from "preact";
import PropTypes from "prop-types";
import { RouteUtils } from "../../utils/RouteUtils";
import Match from "preact-router/match";

class PathRestricted extends Component {
	render({blacklist, whitelist, children}) {
		return <Match>
			{o => RouteUtils.isGraylisted(o.path, blacklist, whitelist, window.location) ? children : null}
		</Match>;
	}

	static get propTypes() {
		return {
			blacklist: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.func]),
			whitelist: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.func]),
		}
	}

	static get defaultProps() {
		return {
			children: null,
		}
	}
}

export default PathRestricted;
